import { Box, Tab, Tabs } from "@mui/material";
import {
  Dispatch,
  SetStateAction,
  useCallback,
  useEffect,
  useState,
} from "react";
import { Country, CountryKey } from "../../../utils/models/Common.model";
import { IssueAndSpecification } from "../../../utils/models/Spec.model";
import { FormTranslation } from "../../Translations/pieces/FormTranslation";
import { FormSpec } from "./FormSpec";

export function TabsLangSpec({
  langs,
  translations,
  setTranslations,
}: {
  langs: CountryKey[];
  translations: IssueAndSpecification["translations"];
  setTranslations: Dispatch<SetStateAction<IssueAndSpecification["translations"]>>;
}) {
  const [value, setValue] = useState<undefined | CountryKey>(undefined);
  useEffect(() => {
    if (value === undefined) {
      setValue(langs[0]);
    }
  }, [langs, value]);
  const setTranslation = useCallback(
    (key: CountryKey, translation: string) => {
      setTranslations((value) => ({
        ...value,
        [key]: translation,
      }));
    },
    [setTranslations]
  );

  return (
    <>
      {langs.length > 0 && (
        <div>
          <Box sx={{ width: "100%" }}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <Tabs
                value={value || false}
                onChange={(_, value) => setValue(value)}
                aria-label="basic tabs example"
              >
                {langs.map((key) => (
                  <Tab key={key} label={Country[key]} value={key} />
                ))}
              </Tabs>
            </Box>
            {langs.map((key) => (
              <div role="tabpanel" key={key} hidden={value !== key}>
                <FormSpec
                  translation={translations[key]}
                  lang={key}
                  onChange={setTranslation}
                />
              </div>
            ))}
          </Box>
        </div>
      )}
    </>
  );
}
